import { render } from "./PhotosView.vue?vue&type=template&id=2cc0b1c0&scoped=true"
import script from "./PhotosView.vue?vue&type=script&lang=js"
export * from "./PhotosView.vue?vue&type=script&lang=js"

import "./PhotosView.vue?vue&type=style&index=0&id=2cc0b1c0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cc0b1c0"]])

export default __exports__